import { IRecord } from "../../interfaces/record";
import * as DetailComponents from "../../components/historyRecordComponents/DetailComponnents";
import { CenterColumns } from "./index.styles";
import { ColumnsType } from "antd/lib/table";

export default function constDataToTableRowsHistoryRecordPAge(
  dataUsers: IRecord[]
) {
  return dataUsers.map((item: IRecord, index: number) => [
    <DetailComponents.Timestamp key={index} timestamp={item.timeStamp} />,
    <DetailComponents.ProfileComponent
      name={item.firstName + " " + item.lastName}
      pictureUrl={item.imageUrl}
      displayName={item.displayName}
    />,
    <DetailComponents.Product
      productName={item.product.productName}
      productPrice={item.product.price}
    />,
    <DetailComponents.Summary key={index} summary={item.summary || ""} />,
    <DetailComponents.RenderDoctor key={index} doctorId={item.doctorId} />,
  ]);
}

export const columns: ColumnsType<IRecord> = [
  {
    title: <CenterColumns>วันที่บันทึก</CenterColumns>,
    dataIndex: "timeStamp",
    key: "timeStamp",
    fixed: "left",
    render: (_: string, record: IRecord) => (
      <DetailComponents.Timestamp timestamp={record.timeStamp} />
    ),
  },
  {
    title: <CenterColumns>ชื่อลูกค้า</CenterColumns>,
    dataIndex: "name",
    key: "name",
    render: (_: string, record: IRecord) => (
      <DetailComponents.ProfileComponent
        name={`${record.firstName ?? ""} ${record.lastName ?? ""}`}
        pictureUrl={record.imageUrl}
        displayName={record.displayName}
      />
    ),
  },
  {
    title: <CenterColumns>ประเภทการรักษา</CenterColumns>,
    dataIndex: "product",
    key: "product",
    render: (_: string, record: IRecord) => (
      <DetailComponents.Product
        productName={record.product.productName}
        productPrice={record.product.price}
      />
    ),
  },
  {
    title: <CenterColumns>อาการโดยสรุป</CenterColumns>,
    dataIndex: "summary",
    key: "summary",
    width: 300,
    render: (_: string, record: IRecord) => (
      <DetailComponents.Summary summary={record.summary || ""} />
    ),
  },
  {
    title: <CenterColumns>สัตว์แพทย์ที่ให้คำปรึกษา (Id)</CenterColumns>,
    dataIndex: "doctorId",
    key: "doctorId",
    render: (_: string, record: IRecord) => (
      <DetailComponents.RenderDoctor doctorId={record.doctorId} />
    ),
  },
];
